import { Component, Input, Output, EventEmitter, SimpleChange, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import * as _ from "lodash";
import { ArrayHelperService } from 'src/app/services/common/array-helper.service';
import RecipeNode from '../../subproducts/subproducts-tree/recipe-node';

@Component({
  selector: 'po-prints',
  templateUrl: './po-prints.component.html',
  styleUrls: ['./po-prints.component.scss']
})
export class PoPrintsComponent {

  @Input() wo: any[] = [];

  prints: any[] = [];


  constructor() { }

  ngOnChanges(sc: SimpleChange) {
    if (_.has(sc, 'wo.currentValue') && Object.keys(sc['wo'].currentValue).length > 0) {
      this.prints = sc['wo'].currentValue.Prints;
    }
  }

}
